import { useSize } from 'ahooks';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { pickDomAttrs } from '../_util/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonNode = props => {
  const {
    loading = true,
    active = true,
    radius = true,
    block,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-skeletonNode");
  const attrs = pickDomAttrs(restProps);
  const ref = useRef(null);
  const size = useSize(ref);
  if (children === false || children === null || children === undefined) {
    return null;
  }

  //32 + 16 = 48 * 2 = 96
  const hasBar = !!(size !== null && size !== void 0 && size.height) && size.height > 96 - 16;
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    ref: ref,
    className: classNames(className, baseClassName, {
      block,
      loading,
      active: loading && active,
      radius: loading && radius,
      hasBar: loading && hasBar
    }),
    style: style,
    children: [loading && hasBar && /*#__PURE__*/_jsx("div", {
      className: "bar",
      children: new Array(Math.floor((size.height + 16) / 48)).fill(undefined).map((_, key) => /*#__PURE__*/_jsx("div", {
        className: classNames('bar-item', {
          active,
          radius
        })
      }, key))
    }), children]
  });
};
export default SkeletonNode;